import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[dashboardTemplate-host]',
})

export class DashboardTemplateDirective {
	constructor(public viewContainerRef: ViewContainerRef ) {}
}
